/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { property } from 'lit/decorators.js';
import CDSHeaderMenu from '@carbon/web-components/es/components/ui-shell/header-menu.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import styles from './masthead.scss';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';

const { stablePrefix: c4dPrefix } = settings;

/**
 * Masthead top nav submenu.
 *
 * @element c4d-top-nav-menu
 */
@customElement(`${c4dPrefix}-top-nav-menu`)
class C4DTopNavMenu extends CDSHeaderMenu {
  /**
   * `true` if this submenu should be in its active state.
   */
  @property({ type: Boolean, reflect: true })
  active = false;

  updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has('active')) {
      const { active, _topMenuItem: triggerNode } = this;
      if (triggerNode) {
        triggerNode.setAttribute('data-selected', String(Boolean(active)));
      }
    }

    this.shadowRoot
      ?.querySelectorAll('[role="menuitem"]')
      .forEach((menuItem) => menuItem.removeAttribute('role'));
  }

  connectedCallback() {
    super.connectedCallback();
    this.removeAttribute('role');
  }

  static styles = styles; // `styles` here is a `CSSResult` generated by custom WebPack loader
}

export default C4DTopNavMenu;
